
import React from 'react';
import { motion } from 'framer-motion';
import { Shield, CheckCircle } from 'lucide-react';

interface ComplianceBadgeProps {
  name: string;
  certified: boolean;
  index: number;
}

export const ComplianceBadge: React.FC<ComplianceBadgeProps> = ({ 
  name, 
  certified, 
  index 
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3, delay: index * 0.1 }}
      className="flex items-center gap-2 bg-card border rounded-lg px-4 py-3 transition-all duration-300 hover:shadow-md hover:scale-105"
    >
      <div className={`flex-shrink-0 ${certified ? 'text-green-600' : 'text-amber-600'}`}>
        {certified ? (
          <CheckCircle className="w-5 h-5" />
        ) : (
          <Shield className="w-5 h-5" />
        )}
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium truncate">{name}</p>
        <p className="text-xs text-muted-foreground">
          {certified ? 'Certified' : 'In Progress'}
        </p>
      </div>
    </motion.div>
  );
};
